import React, {Component} from "react"

import {Card} from "@irati/ui/src/Layout"
import {H5} from "@irati/ui/src/Headings"
import {Para} from "@irati/ui/src/Labels"
import {FormattedMessage} from "@irati/utils/lang"

class AnalysisEmptyState extends Component {
  render() {
    return (
      <Card>
        <H5 bold base><FormattedMessage id="insights.analysis.emptyState.heading" /></H5>
        <Para><FormattedMessage id="insights.analysis.emptyState.body" /></Para>
      </Card>
    )
  }
}

export default AnalysisEmptyState
